import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Modal, Row, Select, Space, theme } from "antd"
import React, { useEffect } from "react";
import { FORMAT_DATE, PASSWORD_DEFAULT, requiredItem, TYPE_MODAL } from "../../../constants/constants";
import { consoleLogUtil } from "../../../utils/consoleLogUtil";
import dayjs from "dayjs";
import { CloseOutlined, SaveOutlined } from "@ant-design/icons";

const ModalAddAndEdit = ({ visible, onCancel, onSave, data, title, type, lstBranch, lstPositions }) => {
    const [form] = Form.useForm();
    const { token } = theme.useToken();
    consoleLogUtil("dataaa", data)
    consoleLogUtil("lstBranch", lstBranch)
    const formStyle = {
        maxWidth: 'none',
        background: token.colorFillAlter,
        borderRadius: token.borderRadiusLG,
        padding: 24,
    };
    const handleFinish = (values) => {
        console.log(values);
        if (type === TYPE_MODAL.ADD) {
            onSave({
                ...values,
                birth_date: values?.birth_date ? values?.birth_date?.format("YYYY-MM-DD") : null,
                start_work_date: values?.start_work_date ? values?.start_work_date?.format("YYYY-MM-DD") : null,
            });
        } else {
            let tempData = { ...values };
            tempData.id = data.id;
            tempData.birth_date = values?.birth_date ? values?.birth_date?.format("YYYY-MM-DD") : null;
            tempData.start_work_date = values?.start_work_date ? values?.start_work_date?.format("YYYY-MM-DD") : null;
            onSave(tempData);
        }
    };

    useEffect(() => {
        if (type === TYPE_MODAL.EDIT) {
            form.setFieldsValue({
                ...data,
                birth_date: data?.birth_date ? dayjs(data?.birth_date) : null,
                start_work_date: data?.start_work_date ? dayjs(data?.start_work_date) : null,
            });
        } else {
            form.resetFields();
        }
    }, [data, type, visible]);

    useEffect(() => {
        if (data && lstBranch?.length > 0) {
            form.setFieldsValue({
                branch_id: data.branch_id,
            });
        }

        if (data && lstPositions?.length > 0) {
            form.setFieldsValue({
                position_id: data.position_id ? parseInt(data.position_id) : null
            });
        }

    }, [form, lstBranch, data])

    return (
        <Modal
            title={title}
            open={visible}
            onCancel={onCancel}
            width={'80%'}
            footer={null}
        >
            <Form form={form} layout="vertical" name="add-edit-account" style={formStyle} onFinish={handleFinish}>
                <Row gutter={16}>
                    <Col span={6}>
                        <Form.Item
                            label="Tên nhân viên"
                            name="full_name"
                            rules={requiredItem}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={5}>
                        <Form.Item
                            label="Số điện thoại"
                            name="phone"
                            rules={requiredItem}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Form.Item
                            label="Ngày sinh"
                            name="birth_date"
                        >
                            <DatePicker style={{ width: '100%', height: 40 }} format={FORMAT_DATE.DDMMYYYY}/>
                        </Form.Item>
                    </Col>
                    <Col span={9}>
                        <Form.Item
                            label="Địa chỉ"
                            name="address"
                            rules={requiredItem}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={5}>
                        <Form.Item
                            label="Chi nhánh"
                            name="branch_id"
                            rules={requiredItem}
                        >
                            <Select
                                style={{ width: '100%', height: 40 }}
                                placeholder="Chọn chi nhánh"
                                maxTagCount={'responsive'}
                                options={lstBranch?.map(item => ({
                                    ...item,
                                    label: item.name,
                                    value: item.id
                                }))}
                            />
                        </Form.Item>
                    </Col>
                    
                    <Col span={5}>
                        <Form.Item
                            label="Chức vụ"
                            name="position_id"
                            rules={requiredItem}
                        >
                            <Select
                                style={{ width: '100%', height: 40 }}
                                placeholder="Chọn chức vụ"
                                maxTagCount={'responsive'}
                                options={lstPositions?.map(item => ({
                                    ...item,
                                    label: item.name,
                                    value: parseInt(item.id)
                                }))}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={5}>
                        <Form.Item
                            label="Ngày bắt đầu làm việc"
                            name="start_work_date"
                            rules={requiredItem}
                        >
                            <DatePicker style={{ width: '100%', height: 40 }} format={FORMAT_DATE.DDMMYYYY}/>
                        </Form.Item>
                    </Col>
                    <Col span={5}>
                        <Form.Item
                            label="Lương cơ bản (VNĐ)"
                            name="salary_base"
                            rules={requiredItem}
                        >
                            <InputNumber
                                className="input-number-cus-ant cus-height-40" 
                                min={0} 
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Form.Item
                            label="Phụ cấp (VNĐ)"
                            name="allowance"
                        >
                            <InputNumber
                                className="input-number-cus-ant cus-height-40" 
                                min={0} 
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                            />
                        </Form.Item>
                    </Col>

                </Row>
                <Row gutter={16} justify={'end'}>
                    <Space>
                        <Button onClick={onCancel} icon={<CloseOutlined />}>
                            Đóng
                        </Button>
                        <Button type="primary" htmlType="submit" icon={<SaveOutlined />}>
                            Lưu
                        </Button>
                    </Space>
                </Row>
            </Form>
        </Modal>
    )
}
export default React.memo(ModalAddAndEdit);